export const CHAT_STRINGS = {
  es: {
    title: "Asistente Saga",
    subtitle: "En línea · responde en tu idioma",
    welcome: "¡Hola! Soy Saga, la asistente virtual de Sagas Logistic. Puedo contarte sobre nuestros servicios de consultoría, logística, trámites y transporte. ¿En qué te ayudo?",
    placeholder: "Escribe tu pregunta...",
    whatsapp: "WhatsApp",
    lead: "Dejar mis datos",
    leadName: "Tu nombre",
    leadContact: "Correo o teléfono",
    leadSubmit: "Enviar",
    leadDone: "¡Gracias! Un asesor te contactará pronto.",
    error: "Tuve un problema técnico. Escríbenos por WhatsApp, por favor.",
    typing: "Saga está escribiendo...",
  },
  en: {
    title: "Saga Assistant",
    subtitle: "Online · replies in your language",
    welcome: "Hi! I'm Saga, Sagas Logistic's virtual assistant. I can tell you about our consulting, logistics, permits, and transport services. How can I help?",
    placeholder: "Type your question...",
    whatsapp: "WhatsApp",
    lead: "Leave my details",
    leadName: "Your name",
    leadContact: "Email or phone",
    leadSubmit: "Send",
    leadDone: "Thank you! An advisor will contact you soon.",
    error: "I had a technical issue. Please reach us on WhatsApp.",
    typing: "Saga is typing...",
  },
  pt: {
    title: "Assistente Saga",
    subtitle: "Online · responde no seu idioma",
    welcome: "Olá! Sou a Saga, assistente virtual da Sagas Logistic. Posso falar sobre nossos serviços de consultoria, logística, tramitações e transporte. Como posso ajudar?",
    placeholder: "Escreva sua pergunta...",
    whatsapp: "WhatsApp",
    lead: "Deixar meus dados",
    leadName: "Seu nome",
    leadContact: "E-mail ou telefone",
    leadSubmit: "Enviar",
    leadDone: "Obrigado! Um consultor entrará em contato em breve.",
    error: "Tive um problema técnico. Fale conosco pelo WhatsApp, por favor.",
    typing: "Saga está digitando...",
  },
};
